import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import ReviewCard from './ReviewCard';
import { map } from 'lodash';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import PageLoader from '../common/PageLoader';
import { imageBasePath } from '../../constants/staticData';
import InfiniteScroll from 'react-infinite-scroller';
import MobileHeaderSearch from '../common/MobileHeaderSearch';

class ReviewRating extends Component {
  constructor() {
    super();
    this.state = {
      searchMobile: false,
      reviewsLoaded: true,
      ratingDDVisible: false,
      ratingSort: 'new-old',
      notificationVisible: false,
      showSidebar: false,
      review: [],
      fetchingData: false,
      selectedSort: 'date=-1'
    };
  }
  componentWillMount() {

    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    if (authData.garageId) {
      this.props.actions.getVendorReviewsAndRatings(authData.garageId, 'date=-1', 0, 10);
    }
  }
  addReply(enteredComments, replyIndex) {
    let values = [...this.state.review];
    map(values, (val, key) => {
      if (val.id == replyIndex) {
        val.reply.push({ name: 'Brnady', comment: enteredComments });
      }
    });
    this.setState({ review: values });
  }
  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar });
  }
  sentReply(reply, commentId, replyIndex) {
    let values = [...this.state.review];
    map(values, (val, key) => {
      if (val.id == commentId) {
        val.reply[replyIndex].comment = reply;
      }
    });
    this.setState({ review: values });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.vendorProfileReducer && nextProps.vendorProfileReducer.reviewsAndRatingsDataLoaded) {
      this.setState({ reviewsLoaded: nextProps.vendorProfileReducer.reviewsAndRatingsDataLoaded });
    }
    if (
      nextProps.vendorProfileReducer &&
      nextProps.vendorProfileReducer.reviewsAndRatingsData &&
      nextProps.vendorProfileReducer.reviewsAndRatingsData.length
    ) {
      this.setState({ review: nextProps.vendorProfileReducer.reviewsAndRatingsData, fetchingData: false });
    }
  }
  render() {
    const { vendorProfileReducer, commonReducer, actions, router, authReducer } = this.props;
    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    return (
      <div>
        {/*Header*/}
        <Header
          searchMobile={this.state.searchMobile}
          hideOption={() => this.setState({ searchMobile: true })}
          commonReducer={commonReducer}
          actions={actions}
          authReducer={authReducer}
          notificationCount={2}
          profileName="Derrick Frank"
          notificationCallBack={this.toggleNotification}
          hCallback={() => {
            this.hclickCallBack();
          }}
          router={router}
          isNewUser={
            authData &&
              authData.isBusinessRegistered &&
              authData.isGarageProfileCompleted &&
              authData.isGarageServiceSelected
              ? false
              : true
          }
        />
        <MobileNotification isVisible={this.state.notificationVisible} backBtnCallBack={this.toggleNotification} />
        <div className="main-wrapper manage-profile">
          {/*Sidebar*/}
          <Sidebar
            showSidebar={this.state.showSidebar}
            router={router}
            actions={actions}
            commonReducer={commonReducer}
          />
          <div className="container-fluid main-container review-rating">
            <div className="col-md-12 review-rating-pad">
              <div className="overview-heading row">
                <h5 className="review-rating-header-mob">Review & Rating</h5>
                <span className={this.state.ratingDDVisible ? 'rating-Dd active m-ub-20' : 'rating-Dd m-ub-20'}>
                  <DropdownButton
                    pullRight
                    noCaret
                    bsSize="xsmall"
                    onSelect={e => {
                      let queryParams = 'date=-1';
                      if (e == 'new-old') {
                        queryParams = 'date=-1';
                      } else if (e == 'old-new') {
                        queryParams = 'date=1';
                      } else if (e == 'high-low') {
                        queryParams = 'rating=-1';
                      } else if (e == 'low-high') {
                        queryParams = 'rating=1';
                      }
                      this.setState({ ratingSort: e, selectedSort: queryParams });
                      this.props.actions.getVendorReviewsAndRatings(authData.garageId, queryParams, 0, 10);
                    }}
                    onToggle={e => this.setState({ ratingDDVisible: e })}
                    title={
                      <span className="holder">
                        <i className="mdi mdi-swap-vertical pull-left active" />
                        <label>Sort</label>
                        <i
                          className={
                            this.state.ratingDDVisible
                              ? 'mdi mdi-chevron-up pull-right'
                              : 'mdi mdi-chevron-down pull-right'
                          }
                        />
                      </span>
                    }
                    id="dropdown-rating"
                  >
                    <MenuItem eventKey="new-old">
                      Date: Newest to Oldest
                      <i className={this.state.ratingSort == 'new-old' ? 'mdi mdi-check active' : 'mdi mdi-check'} />
                    </MenuItem>
                    <MenuItem eventKey="old-new">
                      Date: Oldest to Newest
                      <i className={this.state.ratingSort == 'old-new' ? 'mdi mdi-check active' : 'mdi mdi-check'} />
                    </MenuItem>
                    <MenuItem eventKey="high-low">
                      Rating: Highest to Lowest
                      <i className={this.state.ratingSort == 'high-low' ? 'mdi mdi-check active' : 'mdi mdi-check'} />
                    </MenuItem>
                    <MenuItem eventKey="low-high">
                      Rating: Lowest to Highest
                      <i className={this.state.ratingSort == 'low-high' ? 'mdi mdi-check active' : 'mdi mdi-check'} />
                    </MenuItem>

                  </DropdownButton>
                </span>

              </div>
              <div className="content-view">
                {this.state.reviewsLoaded
                  ? this.state.review && this.state.review.length
                    ? <InfiniteScroll
                      pageStart={0}
                      loadMore={() => {
                        if (!this.state.fetchingData) {
                          this.setState({ fetchingData: true });
                          actions.getVendorReviewsAndRatings(
                            authData.garageId,
                            this.state.selectedSort,
                            this.state.review.length,
                            10
                          );
                        }
                      }}
                      hasMore={ vendorProfileReducer.ratingsAndReviews.length >= 10 && vendorProfileReducer.reviewsAndRatingsOverView.totalCount > this.state.review.length}
                      loader={<PageLoader />}
                    >
                      {this.state.review && this.state.review.length
                        ? map(this.state.review, (review, key) => {
                          return (
                            <ReviewCard
                              actions={actions}
                              data={review}
                              index={key}
                              key={key}
                              replyVal={this.addReply.bind(this)}
                              sentReply={this.sentReply.bind(this)}
                            />
                          );
                        })
                        : <div />}
                    </InfiniteScroll>
                    : <div className="content-view">
                      {' '}
                      <div className="empty-state-holder">
                        <span className="empty-state-content">
                          <img src={`${imageBasePath}/request_empty.png`} />
                          <span>Oops! Looks like you have not yet been reviewed. </span>
                        </span>
                      </div>
                    </div>
                  : <PageLoader />}
              </div>
            </div>
          </div>
        </div>
        {this.state.searchMobile &&
          <div>

            <MobileHeaderSearch
              mobile={true}
              actions={this.props.actions}
              commonReducer={this.props.commonReducer}
              mobSearchClick={() => this.setState({ searchMobile: false })}
            />
          </div>}
      </div>
    );
  }
}

export default ReviewRating;



// WEBPACK FOOTER //
// ./src/components/ReviewRating/ReviewRating.jsx